import { render, staticRenderFns } from "./ActivityListItem.vue?vue&type=template&id=55142d8c&"
import script from "./ActivityListItem.vue?vue&type=script&lang=js&"
export * from "./ActivityListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ActivityListItem.vue"
export default component.exports